import {Fancybox} from "@fancyapps/ui";

Fancybox.bind('[data-fancybox="gallery"]', {
    // Options will go here
});

Fancybox.bind('[data-fancybox]:not([data-fancybox="gallery"])', {
    // Single-item triggers (videoBlock, blogMedia poster, etc.)
});